import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { IStudioStore } from '../../../stores/StudioStore'
import TimelineControls from '../common/TimelineControls'
import { formatTime } from '../PlayerUtils'

interface SongTimelineControlsProps {
  player: IStudioStore
}

const SongTimelineControls: FC<SongTimelineControlsProps> = ({ player }) => {
  const { currentTimestampInSeconds, playhead, userSetPlayhead, song } = player
  const songLength16thNotes = song.songMintLength16Notes
  const formattedDuration = formatTime(song.songMintLengthSeconds)
  const formattedCurrentTime = formatTime(currentTimestampInSeconds)
  const handleChange = ([value]) => {
    userSetPlayhead(value)
  }
  return (
    <TimelineControls
      value={playhead}
      max={songLength16thNotes}
      onValueChange={handleChange}
      onSlideStart={() => player.disableAudioUpdates()}
      onSlideEnd={() => player.enableAudioUpdates()}
      leftLabel={formattedCurrentTime}
      rightLabel={formattedDuration}
    />
  )
}

export default observer(SongTimelineControls)
